'use client';

import { useParams } from 'next/navigation';

import NavList, { MenuItem } from '@/features/header/NavList';
import { COMMON_I18N } from '@/lib/i18n/commonI18n';

const DesktopNav = ({ items }: DesktopNavProps) => {
  const { locale: raw } = useParams<{ locale?: string }>();
  const locale = raw === 'en' ? 'en' : 'pt';
  const t = COMMON_I18N[locale];

  return (
    <nav
      aria-label={t.mainNavigation}
      className="hidden desktop:flex items-center gap-8"
    >
      <NavList items={items} variant="desktop" />
    </nav>
  );
};

export default DesktopNav;

type DesktopNavProps = {
  items: MenuItem[];
};
